import {React } from "react";
import './Inputstyle.css';

export default function Input({minWidth = '5px', fontWeight = 'normal',label,type='text',autoComplete='off',...props}) {

  return (
    <div className="input-container" style={{minWidth: minWidth}}>
      {type !== 'submit' || type !== 'reset' ? label !== undefined ? <label style={{fontWeight: fontWeight}} className={props.required ? 'imp' : ''}>{label}</label> : <></> : <></>}
      <input 
      className={'main-input'}
        type={type}
        autoComplete={autoComplete}
        {...props}
      /> 
      {/* {error && <p className="error-message">{errorMessage}</p>} */}
      
    </div>
  );
}
